import { LoadSurgicalOrdersByDoctor } from 'domain/usecases/doctor/load-surgical-order'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadSurgicalOrderByDoctor
  implements LoadSurgicalOrdersByDoctor
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  loadOrders(
    params: LoadSurgicalOrdersByDoctor.Params
  ): Promise<LoadSurgicalOrdersByDoctor.Model> {
    return this.doctorRepository.loadSurgicalOrdersByDoctor(params)
  }
}
